import React from 'react';
import EstimatesCategory from './EstimatesCategory';
import './estimates.scss';
import './EstimatesTemplates.scss';

function EstimatesCategoryPage() {
  return (
    <div className="estimates-container p-3 min-vh-100 bg-secondary bg-opacity-10">
     <div className="estimates-header p-3 bg-white rounded-3 shadow-2 mb-3">
        <h2 className="m-0 text-black fw-bold fs-4">Estimate Categories</h2>
      </div>
      <div className="estimates-content bg-white rounded-3 shadow-2 overflow-hidden">
        <EstimatesCategory />
      </div>
    </div>
  );
}

export default EstimatesCategoryPage;
